const state = {
  userInfo: {} //存访问该页面的所有用户
};
const getters = {
  getUsers(state) { //获取访问该页面的所有用户
    // 对数据清理-除去脏数据
    // if (state.users.includes('*')) delete state.users['*']
    return state.userInfo;
  }
};
import {
  BASE_URL
} from "@/utils/base.js";
const mutations = {
  //获取用户信息
  getUserInfo(state, info) {
    state.userInfo = info;
    if (Object.keys(state.userInfo).length > 0) {
      state.userInfo.fan = BASE_URL + state.userInfo.fan
      state.userInfo.zheng = BASE_URL + state.userInfo.zheng
      state.userInfo.head = BASE_URL + state.userInfo.head
    }

  },
  addUser(state, name) { //增加访问用户
    state.collects.push(name)
  }
};
const actions = {
  invokeAddUser(context, name) { //触发mutations里面的addUser,传入数据形参name对应到users
    context.commit('addUser', name);
  }
};
// 注意和仓库的区别
const store = {
  // namespaced用于在全局引用此文件里的方法时标识这一个的文件名，使得让人明白这些数据来自哪个仓库
  // 即当你需要在别的文件里面使用子仓库(mapStates、mapGetters、mapActions)时，里面的方法需要注明来自哪一个模块的方法
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export default store;